import {
	type CommandConstructor,
	type CommandProperties,
	type SerializableValue,
} from '@atlassian/rovo-content-bridge-api/command';
import { createCommand } from '@atlassian/rovo-content-bridge-api/command-creator';

/**
 * Data payload for action classification metadata.
 */
export type ActionClassificationMetadata = {
	/**
	 * The version of the prompt used for classification.
	 */
	promptVersion: string;
};

/**
 * Properties for the action classification command.
 *
 * @extends CommandProperties
 */
export interface ActionClassificationCommandProperties extends CommandProperties {
	/**
	 * The metadata containing promptVersion and any arbitrary key-value pairs.
	 */
	data: ActionClassificationMetadata;
}

/**
 * A command sent by a bridge API client to perform action classification.
 *
 * @summary {@link CommandProperties.senderId} is requesting {@link CommandProperties.receiverId} to classify an action with the specified metadata.
 */
export const ActionClassificationCommand: CommandConstructor<
	ActionClassificationCommandProperties,
	SerializableValue
> = createCommand<ActionClassificationCommandProperties>('action-classification-command');
